import {
    PAGE_TITLE_ADDONS,
    PAGE_TITLE_CLIENTS,
    PAGE_TITLE_DASHBOARDS,
    PAGE_TITLE_ORDERS,
    PAGE_TITLE_PROMOACTIONS,
} from '#shared/lib/constants';
import {
    addonsEditRoute,
    addonsRoute,
    clientsRoute,
    dashboardsRoute,
    ordersRoute,
    promoactionBundleRoute,
    promoactionDiscountLadderRoute,
    promoactionGiftsRoute,
    promoactionRoute,
    promoactionsRoute,
    promoRecommendationFormRoute,
} from '#shared/lib/routes';
import { type SidebarMenuItem } from '../types';

export const DASHBOARDS_MENU_ITEM: SidebarMenuItem = {
    href: dashboardsRoute.getUrl(),
    permission: 'analytics',
    iconLabel: '',
    itemId: 'dashboards',
    routes: [dashboardsRoute.route],
    label: PAGE_TITLE_DASHBOARDS,
    title: PAGE_TITLE_DASHBOARDS,
};

export const ADDONS_MENU_ITEM: SidebarMenuItem = {
    href: addonsRoute.getUrl(),
    permission: 'content',
    iconLabel: '',
    itemId: 'addons',
    routes: [addonsRoute.route, addonsEditRoute.route],
    label: PAGE_TITLE_ADDONS,
    title: PAGE_TITLE_ADDONS,
};

export const ORDERS_MENU_ITEM: SidebarMenuItem = {
    href: ordersRoute.getUrl(),
    permission: 'orders',
    iconLabel: '',
    itemId: 'orders',
    routes: [ordersRoute.route],
    label: PAGE_TITLE_ORDERS,
    title: PAGE_TITLE_ORDERS,
    isMobileSupported: true,
};

export const CLIENTS_MENU_ITEM: SidebarMenuItem = {
    href: clientsRoute.getUrl(),
    permission: 'clients',
    iconLabel: '',
    itemId: 'clients',
    routes: [clientsRoute.route],
    label: PAGE_TITLE_CLIENTS,
    title: PAGE_TITLE_CLIENTS,
};

export const PROMOACTIONS_MENU_ITEM: SidebarMenuItem = {
    href: promoactionsRoute.getUrl(),
    permission: 'promotions',
    iconLabel: '',
    itemId: 'promoactions',
    routes: [
        promoactionsRoute.route,
        promoactionRoute.route,
        promoactionBundleRoute.route,
        promoactionGiftsRoute.route,
        promoactionDiscountLadderRoute.route,
        promoRecommendationFormRoute.route,
    ],
    label: PAGE_TITLE_PROMOACTIONS,
    title: PAGE_TITLE_PROMOACTIONS,
};
